/* eslint-disable */
import React, { useLayoutEffect, useState } from "react";
import { useSearchContent } from "../../common/redux/searchContent";
import { IFacet, ITerm } from "../../common/api/searchApi.types";
import { IFacetsProps, IFacetProps, ITermProps } from "./facets.types";
import { v4 as uuidv4 } from "uuid";
import MediaQuery from "react-responsive";

const Facets: React.FC<IFacetsProps> = ({
  facets,
  selectedTerms,
  onTermClick,
  onResetClick,
}) => {
  const [showFacets, setShowFacets] = useState<boolean>(false);
  const searchContent = useSearchContent();

  const renderFacet = (value: IFacet) => {
    return (
      <Facet
        facet={value}
        key={uuidv4()}
        selectedTerms={selectedTerms}
        onTermClick={onTermClick}
      />
    );
  };

  const toggleFacets = () => {
    setShowFacets(!showFacets);
  };

  const onClearAll = (e: React.MouseEvent<HTMLButtonElement>) => {
    onResetClick();
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <>
      <div className="filters-heading-row" onClick={toggleFacets}>
        <h2 className="filters-main-heading svg__span--funnel">
          {searchContent.filtersLabel}
        </h2>
        <MediaQuery maxWidth={640}>
          {selectedTerms && selectedTerms.length > 0 && (
            <p>({selectedTerms.length.toString()})</p>
          )}
        </MediaQuery>
        <hr className="d-none d-md-block filters-hr" />
      </div>

      <MediaQuery maxWidth={640}>
        {showFacets &&
          selectedTerms &&
          selectedTerms.length > 0 &&
          facets &&
          facets.facets && (
            <div className="filters-pill-row">
              {selectedTerms.map((x, index) => (
                <button
                  className="pill-button-filter svg__span--close-rev-filters"
                  data-pill-filter="pill-filter"
                  onClick={() => onTermClick(x.id)}
                  key={uuidv4()}
                >
                  {x.term}
                </button>
              ))}
              <button
                className="pill-button-clear svg__span--close-filters"
                data-pill-clear="pill-clear"
                onClick={onClearAll}
              >
                {searchContent.clearAllLabel}
              </button>
            </div>
          )}
        {showFacets &&
          facets &&
          facets.facets.length > 0 &&
          facets.facets.map(renderFacet)}
      </MediaQuery>

      <MediaQuery minWidth={641}>
        {selectedTerms && selectedTerms.length > 0 && (
          <div className="filters-pill-row">
            {selectedTerms.map((x, index) => (
              <button
                className="pill-button-filter svg__span--close-rev-filters"
                data-pill-filter="pill-filter"
                onClick={() => onTermClick(x.id)}
                key={uuidv4()}
              >
                {x.term}
              </button>
            ))}
            <button
              className="pill-button-clear svg__span--close-filters"
              data-pill-clear="pill-clear"
              onClick={onClearAll}
            >
              {searchContent.clearAllLabel}
            </button>
          </div>
        )}

        {facets && facets.facets && facets.facets.map(renderFacet)}
      </MediaQuery>
    </>
  );
};

export default Facets;

const Facet: React.FC<IFacetProps> = ({
  facet,
  selectedTerms,
  onTermClick,
}) => {
  const [showChildren, setShowChildren] = useState<boolean>(false);

  useLayoutEffect(() => {
    if (facet.terms && facet.terms.some((x) => x.selected)) {
      setShowChildren(true);
    }
  });

  const renderTerms = (value: ITerm, index: number) => {
    return (
      <Term
        key={uuidv4()}
        selected={selectedTerms.some((x) => x.id === value.id)}
        term={value}
        onTermClick={onTermClick}
      />
    );
  };

  return (
    <>
      {facet && facet.terms && facet.terms.length > 0 && (
        <>
          <a
            className={`d-block filters-results filters-svg svg__span--carat-${
              showChildren ? "down" : "up"
            }-sm text-underline`}
            data-results-button="results-button"
            role="button"
            onClick={() => setShowChildren(!showChildren)}
          >
            {facet.displayName}
          </a>

          {showChildren && (
            <ul className="filters-ul" data-type-filters="filters-accordion">
              {facet.terms
                .filter((x) => x.term && x.term.length > 0 && x.term != "null")
                .map(renderTerms)}
            </ul>
          )}
        </>
      )}
    </>
  );
};

const Term: React.FC<ITermProps> = ({ term, selected, onTermClick }) => {
  const id = `${term.fieldName}.${term.term}`;
  return (
    <li>
      <label className="filters-input-label">
        {term.term} ({term.hits})
        <input
          type="checkbox"
          onChange={() => onTermClick(term.id)}
          id={id}
          name={id}
          checked={selected}
          value={term.term}
        />
        <span className="filters-input-checkmark" />
      </label>
    </li>
  );
};
